import { styled } from "@mui/material/styles";
import {
  Button,
} from "@mui/material";

// button style
// export const BootstrapButton = styled(Button)({
//   boxShadow: "none",
//   textTransform: "none",
//   fontSize: 14,
//   padding: "3px 10px",
//   border: "1px solid",
//   lineHeight: 1.5,
//   backgroundColor: "#069DAE",
//   fontFamily: ["Roboto"].join(","),
//   "&:hover": {
//     backgroundColor: "#0696A6",
//     boxShadow: "none",
//   },
//   "&:active": {
//     boxShadow: "none",
//     backgroundColor: "#0062cc",
//     borderColor: "#005cbf",
//   },
//   "&:focus": {
//     boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
//   },
// });

export const BootstrapButton = styled(Button)({
  backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
  border: "1px solid hsl(186, 89.90%, 27.30%)",
  borderRadius: "4px",
  color: "#fff",
  fontSize: { xs: "14px", sm: "16px" },
  padding: "4px 10px",
  textTransform: "none",
  "&:hover": {
    backgroundImage: "linear-gradient(#0991a2, #057d8c)",
  },
});